import React from "react";
import { useAccount } from "wagmi";
import { useTranslation } from "react-i18next";

import Portal from "@src/components/overlay/Portal/Portal";
import Backdrop from "@src/components/ux/Backdrop/Backdrop";
import Modal from "@src/components/overlay/Modal/Modal";
import Stack from "@src/components/arrangement/Stack/Stack";
import Group from "@src/components/arrangement/Group/Group";
import WalletAddress from "@src/components/common/WalletAddress/WalletAddress";
import ModalStatusIcon from "@src/components/ux/ModalStatusIcon/ModalStatusIcon";
import Button from "@src/components/dataEntry/Buttons/Button/Button";

import "./ErrorTxModal.scss";

export interface ErrorTxModalProps {
  title?: string;
  info?: {
    title?: string;
    description?: string;
  };
  retryText?: string;
  closeText?: string;
  onRetry?(): void;
  onClose?(): void;
}

const ErrorTxModal = ({ title, info, retryText, closeText, onRetry, onClose }: ErrorTxModalProps) => {
  const { address } = useAccount();
  const { t } = useTranslation("modals");

  return (
    <Portal>
      <Backdrop open>
        <Modal>
          <Stack rowGap={24} alignItems="center" className="error-tx-modal">
            <Group justifyContent="flex-end" fullWidth>
              <WalletAddress address={address ?? ""} />
            </Group>
            <ModalStatusIcon variant="error" />

            <h2>{title ?? t("txModalErrorDefault.title")}</h2>
            <div className="description text-center">
              <p className="p0 bold">{info?.title ?? t("txModalErrorDefault.info.title")}</p>
              <p className="p0">{info?.description ?? t("txModalErrorDefault.info.description")}</p>
            </div>

            <Stack rowGap={24} fullWidth className="mt-4">
              {onRetry && (
                <Button fullSize onClick={onRetry}>
                  {retryText ?? t("txModalErrorDefault.retryText")}
                </Button>
              )}

              {onClose && (
                <Button variant="secondary" fullSize onClick={onClose}>
                  {closeText ?? t("txModalErrorDefault.closeText")}
                </Button>
              )}
            </Stack>
          </Stack>
        </Modal>
      </Backdrop>
    </Portal>
  );
};

export default ErrorTxModal;
